module.exports = __webpack_public_path__ + "img/logo.c86f335f.svg";